import { alarmCRUD, type AlarmCrudType } from './alarm-crud'
import { applicationCrud, type ApplicationCrudType } from './application-crud'
import { blobCRUD, type BlobCrudType } from './blob-crud'
import { facilityCRUD, type FacilityCrudType } from './facility-crud'
import { photovoltaicCRUD, type PhotovoltaicCrudType } from './photovoltaic-crud'
import { plcCRUD, type PLCCrudType } from './plc-crud'
import { roleCRUD, type RoleCrudType } from './role-crud'
import { userCRUD, type UserCrudType } from './user-crud'

type ApiType = () => {
    application: ApplicationCrudType
    blob: BlobCrudType
    facility: FacilityCrudType
    user: UserCrudType
    role: RoleCrudType
    plc: PLCCrudType
    alarm: AlarmCrudType
    photovoltaic: PhotovoltaicCrudType
}

const api: ApiType = () => ({
    application: () => applicationCrud(),
    blob: () => blobCRUD(),
    facility: () => facilityCRUD(),
    plc: () => plcCRUD(),
    user: () => userCRUD(),
    role: () => roleCRUD(),
    alarm: () => alarmCRUD(),
    photovoltaic: () => photovoltaicCRUD(),
})

export { api, type ApiType }
